import {createCustomAjvValidator} from "../../../services/AjvValidator";
import React from "react";
import {withTheme} from "@rjsf/core";
import {Theme as Bootstrap4Theme} from "@rjsf/bootstrap-4";
const ThemedForm = withTheme(Bootstrap4Theme);

// This widget is used to provide a default time for the RJSF time widget

const widgetSchema = {
  "properties": {
    "time": {
      "type": "string",
      "format": "time",
    }
  }
}
const uiSchema = {
  "time": {
    "ui:label": false
  }
}

export const TimeWidget = ({value, onChange, schema = {}}) => {

    //TODO: PATTERN VIOLATION - createCustomAjvValidator called on every render (affects 10+ components)
    // Correct solution: Use shared validator from RootUiState (see commented code in src/stores/RootUiState.js)
    // Note: This widget doesn't have StateContext access - pass validator as prop from parent component
    const validator = createCustomAjvValidator()
    const handleOnChange = (e) => {
      const parsedTime = e.formData?.time;
      onChange(parsedTime)
    }

const data = value ? {time: value} : {time: schema.default}
  return (
    <ThemedForm
      schema={widgetSchema}
      formData={data}
      uiSchema={uiSchema}
      validator={validator}
      onChange={(data)=>{handleOnChange(data)}}
    >
      <div></div>
    </ThemedForm>
  );
};
